import { HomeOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { FaUsers, FaHandsHelping, FaPlusCircle } from "react-icons/fa";
import { RiBuilding2Fill, RiAdminFill } from "react-icons/ri";
import { AiTwotoneMedicineBox } from "react-icons/ai";
import { MdWorkspacePremium, MdMeetingRoom } from "react-icons/md";

import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import logo from "../../images/logo.png";
const { Sider } = Layout;

const items = [
  {
    label: "Ana Səhifə",
    icon: <HomeOutlined />,
    key: "/",
  },
  {
    label: "Şirkətlər",
    icon: <RiBuilding2Fill />,
    key: "/companies",
  },
  {
    label: "Şöbələr",
    icon: <AiTwotoneMedicineBox />,
    key: "/departments",
  },
  {
    label: "Vəzifələr",
    icon: <MdWorkspacePremium />,
    key: "/positions",
  },
  {
    label: "Əməkdaşlar",
    icon: <FaUsers />,
    key: "/employees",
  },
  {
    label: "Görüş Otaqları",
    icon: <MdMeetingRoom />,
    key: "/meetingrooms",
  },
  {
    label: "Görüşlər",
    icon: <FaHandsHelping />,
    key: "/meetings",
  },

  {
    label: "Görüş Əlavə Et",
    icon: <FaPlusCircle />,
    key: "/addmeeting",
  },
  {
    label: "Adminlər",
    icon: <RiAdminFill />,
    key: "/admins",
  },
];

const SidebarMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState("/");

  useEffect(() => {
    const pathName = location.pathname;
    setSelectedKeys(pathName);
  }, [location.pathname]);

  const siderStyle = {
    overflow: "auto",
    height: "100vh",
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    background:
      "linear-gradient(#880345, #77084e, #700b52, #660e57, #5f105b, #59125e, #501563, #421a6b, #3a1d70, #3a1d70)",
  };

  return (
    <Sider style={siderStyle}>
      <div className="logo-container">
        <img className="logoStyle" alt="logo" src={logo} />
      </div>
      <hr></hr>
      <Menu
        style={{
          background: "transparent",
          color: "#ffffff",
          fontWeight: "bold",
        }}
        onClick={(item) => {
          navigate(item.key);
        }}
        mode="inline"
        selectedKeys={[selectedKeys]}
        items={items}
      />
    </Sider>
  );
};

export default SidebarMenu;
